<template>
  <form @submit.prevent="submit" :class="errorClass">
    <rp-consent v-if="!surgeryStep" />

    <rp-textinput
      v-model="resource.patient_id"
      placeholder="Patient ID"
      :disabled="disabled"
      @input="touch('patient_id')"/>

    <rp-textinput
      v-model="resource.email"
      placeholder="email"
      :error="emailError"
      isRequired
      :disabled="disabled"
      @input="touch('email')"/>

    <rp-textinput
      v-model="resource.phone"
      v-on:input="clearEngagementType"
      placeholder="phone"
      :disabled="disabled"
      :error="phoneFormatError"
      @input="touch('phone')"/>

    <rp-radios
      v-if="false"
      label="Contact Type"
      helper-text="Select the preferred means of contact"
      :disabled="disabled"
      :error="engagementTypeError"
      required="true">
      <rp-radio v-for="etype in engagementTypes"
        v-bind:key="etype.id"
        v-model="resource.engagement_type_id"
        name="radio"
        :bit= etype.id
        :label= etype.name
        :disabled="disabled" />
    </rp-radios>

    <rp-textinput
      v-model="resource.first_name"
      placeholder="First Name"
      :disabled="disabled"
      @input="touch('first_name')"/>

    <rp-textinput
      v-model="resource.last_name"
      placeholder="Last Name"
      :disabled="disabled"
      @input="touch('last_name')"/>

    <rp-select
      class="gender"
      v-model="resource.gender"
      placeholder="Gender"
      @input="touch('gender')"
      :disabled="disabled">
      <option v-for="gender in genders" :key="gender.value" :value="gender.value">
        {{gender.label}}
      </option>
    </rp-select>

    <rp-select
      class="language"
      v-model="resource.locale"
      placeholder="Language spoken"
      @input="touch('locale')"
      :disabled="disabled"
      isRequired
      :error="localeError">
      <option v-for="locale in locales" :key="locale.id" :value="locale.id">
        {{locale.name}}
      </option>
    </rp-select>

    <rp-datepicker
      v-model="resource.yob"
      placeholder="Year of Birth"
      :yearFromOffset="-100"
      yearOnly
      @input="touch('yob')"
      :disabled="disabled"/>

    <rp-checkbox
      v-if="!surgeryStep"
      v-model="resource.accept_terms"
      @input="touch('accept_terms')"
      isRequired
      :error="accept_termsError"
      label="I confirm that I have read the consent statement to the patient and received their oral consent"/>

    <rp-button :disabled="isInvalid" type="primary">{{buttonText}}</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required, requiredIf, sameAs, helpers} from 'vuelidate/lib/validators'
  import {date} from '../../../api/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Consent from '../../../components/ui/ConsentStatement'
  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import DatePicker from '../../../components/ui/inputs/DatePicker'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import Checkbox from '../../../components/ui/inputs/Checkbox'
  import Radio from '../../../components/ui/inputs/Radio'
  import Radios from '../../../components/ui/inputs/Radios'

  const phoneRegex = /^\+[1-9]\d{6,14}$/
  const phoneValidator = helpers.regex('phone', phoneRegex)

  export default {
    name: 'PatientForm',
    mixins: [validationMixin, form],

    components: {
      'rp-consent': Consent,
      'rp-button': Button,
      'rp-password': Password,
      'rp-textinput': TextInput,
      'rp-datepicker': DatePicker,
      'rp-select': Select,
      'rp-checkbox': Checkbox,
      'rp-radio': Radio,
      'rp-radios': Radios
    },

    props: {
      genders: Array,
      locales: Array,
      engagementTypes: Array,
      disabled: Boolean,
      surgeryStep: {type: Boolean, default: false}
    },

    mounted() {
      this.$set(this.resource, 'accept_terms', this.surgeryStep)
    },

    methods: {
      clearEngagementType: function (textVal) {
        if (textVal == '') {
          this.resource.engagement_type_id = null
        }
      },

      isPhoneEnabled() {
        return (this.resource.phone && this.resource.phone != '')
      }
    },

    computed: {
      ...errorMessages([
        'email',
        'locale',
        'accept_terms']),

        buttonText() {
          let editPatient = this.$router.currentRoute.name === 'edit-patient'
          return this.surgeryStep ? 'Add surgery details' :
            editPatient ? 'Update Patient' : 'Add patient'
        },

        phoneFormatError() {
          if (!this.resource.phone || this.resource.phone == '') {
            return ''
          } else if (this.resource.phone) {
            return (phoneRegex.test(this.resource.phone)) ? '' : 
              'Phone number must be in international format e.g. +441234567890'
          }
        },

        engagementTypeError() {
          return (this.resource.engagement_type_id == null) ? 'This field is required' : ''
        }
    },

    validations: {
      resource: {
        email: {required, email},
        locale: {required},
        patient_id: {required:false},
        first_name: {required:false},
        last_name: {required:false},
        gender: {required:false},
        yob: {required:false},
        phone: {required:false, phoneValidator},
        engagement_type_id: {required: requiredIf(function(n) {
          return false //this.isPhoneEnabled()
        })},
        accept_terms: {terms: sameAs( () => true )}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/Patient.vue